<!-- <button nz-button nzType="default" (click)="changeLanguageEN()">English</button>
<button nz-button nzType="default" (click)="changeLanguageZH()">简体中文</button>
<button nz-button nzType="default" (click)="changeLanguageJP()">日本語</button> -->

<a nz-dropdown [nzDropdownMenu]="menu">
    <!-- <img [src]="flags"> -->
    <span>{{displayText}}</span>
    <i nz-icon nzType="down"></i>
  </a>
  <nz-dropdown-menu #menu="nzDropdownMenu" >
    <ul nz-menu nzSelectable>
      <li *ngFor="let item of langPreference" nz-menu-item (click)="changeLanguage(item)"><img [src]="item.flag">{{item.displayText}}</li>
    </ul>
  </nz-dropdown-menu>